<template>
  <div>
    Scheduled Pickup
  </div>
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Scheduled Pickup',
        route: { name: 'manage-accounts-account-pickups-scheduled', params: { accountId: this.$route.params.accountId } }
      },
      title: 'Scheduled Pickups'
    }
  }
}
</script>

<style>

</style>
